<template>
  <div>
    <div class="all_body">
        <div class="us_title">
            <img :src="us_1" alt="">
        </div>
        <div class="us_content">
            <div class="us_content_title">关于我们</div>
            <div class="us_content_title_1">蛋鸡管家APP（北京嘉农在线信息技术有限公司）</div>
            <div class="us_content_1">
                蛋鸡管家APP是一款实用型全国蛋鸡产业信息化平台，它不仅为蛋鸡养殖户免费提供国家最新政策、行
                业新闻等热点资讯以外，更有蛋商加盟为养殖户们提供精确的鸡蛋报价，玉米、豆粕等原料价格，实时
                更新的价格曲线让您对当前行情了如指掌。另外，蛋鸡管家APP可充分利用互联网、物联网优势，实现
                鸡舍实时监测、在线检测，让养殖户足不出户就能享受到疾病诊断等专属服务。
            </div>
            <div class="us_content_img">
                <img :src="us_2" alt="">
            </div>
            <div class="us_content_footer">
                <div class="us_content_footer_1">
                    <ul>
                        <li class="us_content_foor_li"><img :src="jingzhun" alt=""></li>
                        <li>精准全国报价</li>
                        <li>Precise quotation</li>
                    </ul>
                    <ul>
                        <li class="us_content_foor_li"><img :src="yenei" alt="" ></li>
                        <li>业内政策资讯</li>
                        <li>Policy message</li>
                    </ul>
                    <ul>
                        <li class="us_content_foor_li"><img :src="hangye" alt="" ></li>
                        <li>行业大咖分享</li>
                        <li>Professor sharing</li>
                    </ul>
                    <ul>
                        <li class="us_content_foor_li"><img :src="shuju" alt="" class="shuju" ></li>
                        <li>数据指导生产</li>
                        <li>Guide production</li>
                    </ul>
                </div>
            </div>
        </div>
        
    </div>
  </div>
</template>

<script>
export default {
  name: "Us",

  data() {
    return {
        us_1: './static/img/us_1.png',
        us_2: './static/img/us_2.png',
        shuju: './static/img/shuju.png',
        hangye: './static/img/hangye.png',
        yenei: './static/img/yenei.png',
        jingzhun: './static/img/jingzhun.png',
    };
  },
  mounted(){
      this.$store.commit("settab", 4);
  }
};
</script>

<style>
.all_body {
  width: 100%;
  padding-left: 11%;
  padding-right: 10%;
}
.us_title{
    width: 100%;
    height: 500px;
    margin-top: 30px;
}
.us_title img{
    width: 100%;
    height: 100%;
}
.us_content{
    position: relative;
    width: 100%;
    height: 610px;
    margin-top: 12px;
    background: #eeeeee;
    margin-bottom: 300px;
}
.us_content_title{
    text-align: center;
    padding-top: 86px;
    font-size:30px;
    color: #000000;
}
.us_content_title_1{
    height: 24px;
    line-height: 24px;
    margin-top: 128px;
    margin-left: 218px;
    font-size:26px;
    color: #000000;
}
.us_content_1{
    margin-top: 35px;
    margin-left: 218px;
    font-size:14px;
    color: #000000;
    width: 630px;
    color:rgba(62,58,57,1);
}
.us_content_img{
    position: absolute;
    top: 243px;
    left: 989px;
    width: 272px;
    height: 182px;
}
.us_content_img img{
    width: 100%;
    height: 100%;
}
.us_content_footer{
    display: flex;
    justify-content: center;
    align-items: center;
    width: 1073px;
    height: 217px;
    margin: 0 auto;
    margin-top: 110px;
    background:rgba(255,255,255,1);
    box-shadow:0px 5px 16px 0px rgba(35,24,21,0.15);
}
.us_content_footer_1{
    height: 140px;
    margin: 0 auto;
}
.us_content_footer_1 ul{
    float: left;
    list-style: none;
    margin-right: 60px;
    text-align: center;
    font-size: 18px;
    color:rgba(62,58,57,1);
    white-space:nowrap
}
.us_content_footer_1 ul:last-child{
    margin-right: 0;
}
.us_content_footer_1 ul li{
    margin-top: 2px;
}
.us_content_foor_li{
    width: 80px;
    height: 80px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0 auto;
    margin-bottom: 24px;
}

</style>



// WEBPACK FOOTER //
// src/components/Us.vue